import axios from 'axios';
import Logout from './Logout/Logout';
axios.defaults.withCredentials = true;

const axiosConfig = () => {
    return {
        headers: {
            'withCredentials': true,
            'Content-Type': 'application/json;charset=UTF-8',
           }
      };
}

export const apiCall = async (pmethod,purl,preqObj) => {
  if(localStorage.getItem('token')){
    return Logout()
  }
  if(pmethod === "post" || pmethod === "patch"){
    return axios[pmethod](purl,preqObj,axiosConfig())
    .then(response =>{
      return response;
    }).catch(err =>{
      if(err.response.data.status===401 ||err.response.status===401){
        Logout()
      }else{
       return err.response
      }
    })
  }
  else if(pmethod === "get"){
    let lconfig = axiosConfig();
    lconfig.params = preqObj;
    return axios[pmethod](purl, lconfig)
    .then(response =>{
      return response;
    }).catch(err =>{
      if(err.response.status===401){
         Logout()
      }else{
        return err.response
      }
    })
  }
};

export const storeData = (pkey,pvalue) => {
  localStorage.setItem(pkey, pvalue);
}

export const retrieveData = (pkey) => {
  return localStorage.getItem(pkey);
}

export const encryptStr = (pstr) => {
  return window.btoa(pstr);
}

export const decryptStr = (pstr) => {
  return window.atob(pstr);
}

export const outTxtByTime = () => {
  let today = new Date();
  let loutTxt = "";
  let curHr = today.getHours();
  if (curHr < 12) {
    loutTxt = 'Good Morning';
  } else if (curHr < 16) {
    loutTxt = 'Good Afternoon';
  } else if (curHr < 20){
    loutTxt = 'Good Evening';
  }else{
    loutTxt = 'Good To See You';
  }
  return loutTxt;
}

export const numberWithCommas = (x) =>{
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const heightWidthCalc = () => {
  var w = window.innerWidth
  || document.documentElement.clientWidth
  || document.body.clientWidth;

  var h = window.innerHeight
  || document.documentElement.clientHeight
  || document.body.clientHeight;

  return {
    height : h,
    width: w
  }
}
